import { render, staticRenderFns } from "./_.page.vue?vue&type=template&id=78f69fcc&scoped=true&"
import script from "./_.page.vue?vue&type=script&lang=js&"
export * from "./_.page.vue?vue&type=script&lang=js&"
import style0 from "./_.page.vue?vue&type=style&index=0&id=78f69fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f69fcc",
  null
  
)

export default component.exports